import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { NS } from "../../U2202";
import { FaArrowsRotate } from "react-icons/fa6";
import type { U2000GridStateHandlers } from "../../../u2000Core/reducer/formReducer/U2000GridStateHandlers";
import type { U2000TableHandlers } from "../../../u2000Core/types/U2000TableHandlers";
import type { U2202ConnectedUser } from "../../U2202Service";

interface U2202ConnectedUserListToolBarProps {
  gridStateHandlers: U2000GridStateHandlers<U2202ConnectedUser>;
  handlerActions?: U2000TableHandlers<U2202ConnectedUser>;
  onRefresh: () => void;
}

export const U2202ConnectedUserListToolBar: React.FC<U2202ConnectedUserListToolBarProps> = ({
  gridStateHandlers: _gridStateHandlers,
  handlerActions: _handlerActions,
  onRefresh,
}) => {
  const { t } = useTranslation();

  const actions = [
    {
      key: "refresh",
      label: t("btnRefresh", { ns: NS }),
      hasRole: true,
      handleClick: onRefresh,
      icon: FaArrowsRotate,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
